<template>
  <div id="sidebar"
    class="relative h-auto md:h-auto py-6 w-full md:w-auto px-6 border-r border-gray-200 overflow-y-scroll">

    <el-form ref="submitAvailabilityForm" :model="submitAvailabilityForm" :rules="rules">

      <div class="flex">
        <h3 class="font-bold text-xl mb-6">Set availability</h3>

        <div class="right m-1 lato">

          <el-tooltip class="item" effect="light"
            content="Please save your time availability with your speciality and we will match you with relevant opportunities."
            placement="right-start">
            <span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.29 15.29C11.247 15.3375 11.2069 15.3876 11.17 15.44C11.1322 15.4957 11.1019 15.5563 11.08 15.62C11.0512 15.6767 11.0309 15.7374 11.02 15.8C11.0151 15.8666 11.0151 15.9334 11.02 16C11.0166 16.1312 11.044 16.2613 11.1 16.38C11.1449 16.5041 11.2166 16.6168 11.3099 16.7101C11.4032 16.8034 11.5159 16.8751 11.64 16.92C11.7597 16.9729 11.8891 17.0002 12.02 17.0002C12.1509 17.0002 12.2803 16.9729 12.4 16.92C12.5241 16.8751 12.6368 16.8034 12.7301 16.7101C12.8234 16.6168 12.8951 16.5041 12.94 16.38C12.9844 16.2584 13.0048 16.1294 13 16C13.0008 15.8684 12.9755 15.7379 12.9258 15.6161C12.876 15.4943 12.8027 15.3834 12.71 15.29C12.617 15.1963 12.5064 15.1219 12.3846 15.0711C12.2627 15.0203 12.132 14.9942 12 14.9942C11.868 14.9942 11.7373 15.0203 11.6154 15.0711C11.4936 15.1219 11.383 15.1963 11.29 15.29ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17316C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17316C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87103 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21446 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM12 7C11.4731 6.99966 10.9553 7.13812 10.4989 7.40144C10.0425 7.66476 9.66347 8.04366 9.4 8.5C9.32765 8.61382 9.27907 8.74109 9.25718 8.87418C9.23529 9.00726 9.24054 9.14339 9.27263 9.27439C9.30472 9.40538 9.36297 9.52853 9.44389 9.63643C9.5248 9.74433 9.62671 9.83475 9.74347 9.90224C9.86024 9.96974 9.98945 10.0129 10.1233 10.0292C10.2572 10.0454 10.393 10.0345 10.5225 9.99688C10.6521 9.9593 10.7727 9.89591 10.8771 9.81052C10.9814 9.72513 11.0675 9.6195 11.13 9.5C11.2181 9.34739 11.345 9.22078 11.4977 9.13298C11.6505 9.04517 11.8238 8.9993 12 9C12.2652 9 12.5196 9.10536 12.7071 9.29289C12.8946 9.48043 13 9.73478 13 10C13 10.2652 12.8946 10.5196 12.7071 10.7071C12.5196 10.8946 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V13C11 13.2652 11.1054 13.5196 11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14C12.2652 14 12.5196 13.8946 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13V12.82C13.6614 12.58 14.2174 12.1152 14.5708 11.5069C14.9242 10.8985 15.0525 10.1853 14.9334 9.49189C14.8143 8.79849 14.4552 8.16902 13.919 7.71351C13.3828 7.25801 12.7035 7.00546 12 7Z"
                  fill="#D4D4D4" />
              </svg>
            </span>
          </el-tooltip>

        </div>
      </div>

      <div class="lato">

        <el-form-item prop="into_the_future">
          <el-radio v-model="submitAvailabilityForm.into_the_future" :label="1" class="mb-3">Specify Date
            Range</el-radio>
        </el-form-item>

        <div class="hidden md:block">

          <el-form-item prop="dateFilter">
            <el-date-picker :picker-options="{ disabledDate: (time) => disabledEndDate(time, departureDate) }" v-model="submitAvailabilityForm.dateFilter" type="daterange" range-separator="-"
              start-placeholder="Start date" end-placeholder="End date"></el-date-picker>
          </el-form-item>

        </div>

        <div class="block md:hidden">
          <VueCtkDateTimePicker :min-date="new Date(Date.now() - 8.64e7)" v-model="submitAvailabilityForm.dateFilter" :range="true" :only-date="false"
            format="YYYY-MM-DD" />
        </div>

        <el-radio v-model="submitAvailabilityForm.radio" :label="4" class="my-3">Indefinitely into the future</el-radio>

      </div>

      <div class="mt-2 lato">

        <h6 class="font-semibold">Would you like to exclude weekends?</h6>

        <el-form-item prop="exclude_weekends">

          <el-radio-group v-model="submitAvailabilityForm.exclude_weekends" class="flex flex-row"
            @change="toogleWeekends">
            <el-radio :label="12" class="my-3">Yes</el-radio>
            <el-radio :label="11" class="my-3">No</el-radio>
          </el-radio-group>

        </el-form-item>

      </div>

      <div class="lato py-3">

        <h6 class="font-semibold pb-2">Preferred Timezone</h6>

        <div>

          <el-form-item prop="timeZone">

            <el-select v-model="submitAvailabilityForm.timeZone" placeholder="Select Timezone" style="width: 100%">
              <el-option v-for="(item, index) in timeZones" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>

          </el-form-item>

        </div>

      </div>

      <div class="lato py-3">

        <h6 class="font-semibold pb-2">Specialties</h6>

        <div>

          <el-form-item prop="specialty">

            <el-select v-model="submitAvailabilityForm.specialty" placeholder="Select Specialties" multiple
              style="width: 100%">
              <el-option v-for="(item, index) in constants.medicalSpecialities" :key="index" :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>

          </el-form-item>

        </div>

      </div>

      <div class="lato">

        <h6 class="font-semibold pb-2">Consultation Fee</h6>

        <div id="encounter_rate">
          <el-checkbox v-model="submitAvailabilityForm.encounter_rate" class="mb-3 text-lg">Encounter Rate</el-checkbox>

          <div class="ml-0 md:ml-8" id="grey_input">

            <el-form-item prop="encounter_rate">

              <el-tooltip class="item" effect="light" content="Rate per encounter when available" placement="right-start">
                <el-input v-model="submitAvailabilityForm.encounter_rate_amount" placeholder="$0.00"
                  :disabled="submitAvailabilityForm.encounter_rate !== true"></el-input>
              </el-tooltip>

            </el-form-item>

          </div>

          <div class="pt-3 ml-7" v-if="submitAvailabilityForm.encounter_rate === true">

            <el-checkbox v-model="submitAvailabilityForm.oncall_rate" class="mb-3 text-lg">On Call Rate
              (Optional)</el-checkbox>

            <div class="ml-0 md:ml-8" id="grey_input">

              <el-tooltip class="item" effect="light" content="Rate per hour to be on-call for encounters"
                placement="right-start">
                <el-input v-model="submitAvailabilityForm.oncall_rate_amount" placeholder="$0.00"
                  :disabled="submitAvailabilityForm.oncall_rate !== true"></el-input>
              </el-tooltip>

            </div>

          </div>

        </div>

        <div id="encounter_rate" class="pt-3">

          <el-checkbox v-model="submitAvailabilityForm.hourly_rate" class="mb-3 text-lg">Hourly Rate</el-checkbox>

          <div class="ml-0 md:ml-8" id="grey_input">

            <el-tooltip class="item" effect="light" content="Rate per hour for scheduled time periods"
              placement="right-start">
              <el-input v-model="submitAvailabilityForm.hourly_rate_amount" placeholder="$0.00"
                :disabled="submitAvailabilityForm.hourly_rate !== true"></el-input>
            </el-tooltip>

          </div>

        </div>

        <div>

          <button @click.prevent="submitData" style="background: #48BFE3;"
          :disabled="loading == false ? false : true"
            class="text-white bg-submit rounded w-full mt-8 py-2 font-semibold focus:outline-none josefin">
            {{ loading ? 'Submitting...' : 'Save' }}
          </button>

        </div>

      </div>

    </el-form>

  </div>
</template>

<script>
import dayjs from 'dayjs';
import { trimUserId } from '../helpers/functions'
import { mapActions, mapState } from 'vuex'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

export default {
  components: {
    VueCtkDateTimePicker
  },
  props: {
    providerAvailability: {
      type: Object,
    },
    loading: {
      type: Boolean,
    }
  },
  data() {
    return {
      submitAvailabilityForm: {
        radio: 1,
        oncall_rate_amount: '',
        timeZone: '',
        specialty: [],
        oncall_rate: '',
        encounter_rate_amount: '',
        exclude_weekends: '',
        encounter_rate: '',
        hourly_rate: '',
        hourly_rate_amount: '',
        dateFilter: null,
        into_the_future: 1,
      },
      rules: {
        dateFilter: [
          {
            required: true,
            message: 'Please enter available start date and end date',
          },
        ],
        hourly_rate_amount: [
          {
            required: true,
            message: 'Please enter hourly rate'
          }
        ],
        specialty: [
          {
            required: true,
            message: 'Please enter your list of specialties'
          }
        ],
        timeZone: [
          {
            required: true,
            message: 'Please enter your preferred time zone'
          }
        ]
      },
      business: [
        { value: 'Option 1', label: 'Option 1' },
        { value: 'Option 2', label: 'Option 2' },
        { value: 'Option 3', label: 'Option 3' },
        { value: 'Option 4', label: 'Option 4' },
      ],
      timeZones: [
        { value: 'pdt', label: 'Pacific Daylight Time (PDT)' },
        { value: 'mdt', label: 'Mountain Daylight Time (MDT)' },
        { value: 'cdt', label: 'Central Daylight Time (CDT)' },
        { value: 'edt', label: 'Eastern Daylight Time (EDT)' },
      ]
    }
  },
  watch: {
    
    encounter_rate: {
      deep: true,
      immediate: true,
      handler(x) {
        if (x === true) {
          window.scrollTo(0, document.body.scrollHeight);
        } else {
          return false;
        }
      }
    }
  },
  methods: {
    ...mapActions(['getAllConstants', 'fetchProviderAvailability']),
    toogleWeekends(val) {
      if (val === 11) {
        this.$emit('removeWeekends')
      } else {
        this.$emit('enableWeekends')
      }
    },

    disabledEndDate(date, departureDate) {
    if (departureDate) {
      return date.getTime() < departureDate
    } else {
      return date.getTime() < Date.now()  - 8.64e7;
    }
  },
 
    submitData() {
      const data = JSON.parse(localStorage.getItem('payloadData'))
      localStorage.setItem('submitAvailabilityFormData', JSON.stringify(this.submitAvailabilityForm))
      if (data) {
        this.loading = true;
        this.$emit('handleSubmit')
      } else {
       if (this.submitAvailabilityForm.hourly_rate_amount == "") {
          this.$notify({
            title: 'Error',
            message: 'Please enter hourly rate',
            type: 'error',
          })
          this.loading = false;
        } else if (this.submitAvailabilityForm.specialty == "") {
          this.$notify({
            title: 'Error',
            message: 'Please enter your list of specialties',
            type: 'error',
            
          })
          this.loading = false;
        } else if (this.submitAvailabilityForm.timeZone == "") {
          this.$notify({
            title: 'Error',
            message: 'Please enter your preferred time zone',
            type: 'error',
          })
          this.loading = false;
        } else {
          const payload = {
            start_date: dayjs(this.submitAvailabilityForm.dateFilter[0]).format('YYYY-MM-DD'),
            end_date: dayjs(this.submitAvailabilityForm.dateFilter[1]).format('YYYY-MM-DD'),
            into_the_future: this.submitAvailabilityForm.into_the_future === 1 ? false : true,
            exclude_weekends: this.submitAvailabilityForm.exclude_weekends === 11 ? true : false,
            specialties: this.submitAvailabilityForm.specialty,
            languages: ["English"],
            encounter_rate: this.submitAvailabilityForm.encounter_rate_amount === "" ? 0 : this.encounter_rate_amount,
            on_call_rate: this.submitAvailabilityForm.oncall_rate_amount === "" ? 0 : this.oncall_rate_amount,
            hourly_rate: this.submitAvailabilityForm.hourly_rate_amount === "" ? 0 : this.hourly_rate_amount,
            timezone: this.submitAvailabilityForm.timeZone
          }

          localStorage.clear()
          localStorage.setItem('payloadData', JSON.stringify(payload))

          this.$emit('handleSubmit')
        }
      }

    },
    isObjectEmpty(obj) {
      return Object.keys(obj).length === 0;
    }
  },
  async mounted() {
  
    this.getAllConstants()
    const payload = {
      user_id: trimUserId(this.$auth.user.sub),
    }
    await this.fetchProviderAvailability(payload)
      .then((res) => {
        if (!this.isObjectEmpty(res.data)) {
          this.submitAvailabilityForm.encounter_rate_amount = res.data.encounter_rate;
          this.submitAvailabilityForm.hourly_rate_amount = res.data.hourly_rate;
          this.submitAvailabilityForm.oncall_rate_amount = res.data.on_call_rate;
          this.submitAvailabilityForm.specialty = res.data.specialties;
          this.submitAvailabilityForm.timeZone = res.data.timezone;
          this.submitAvailabilityForm.into_the_future = res.data.into_the_future === true ? 1 : 0;
          this.submitAvailabilityForm.exclude_weekends = res.data.exclude_weekends === true ? 11 : 12;
          this.submitAvailabilityForm.dateFilter = [res.data.start_date, res.data.end_date]
        } else {
          this.providerAvailability = {}
        }
      })
      if (this.submitAvailabilityForm.exclude_weekends === 11) {
        this.$emit('removeWeekends')
      } else {
        this.$emit('enableWeekends')
      }
  },
  computed: {
    ...mapState(['constants']),
  }
}
</script>

<style scoped>
#grey_input {
  width: 112px;
}

*>>>.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #292929;
}

*>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #D4D4D4;
  background-color: #ffffff;
}

*>>>.el-checkbox__inner::after {
  border-color: #292929;
}
</style>

<style>
.el-tooltip__popper {
  width: 275px !important;
  height: 73px !important;
  font-size: 14px !important;
  border: 1px solid rgba(226, 222, 222, 0.877) !important;
  box-shadow: 3px 6px 19px -1px rgba(184, 176, 176, 0.56);
}

.el-tooltip__popper[x-placement^=right-start] .popper__arrow::after {
  border-color: none;
}

.el-tooltip__popper[x-placement^=right-start] .popper__arrow {
  display: none;
}

.bg-submit[disabled="disabled"] {
  background-color: #EEEEEE !important;
}
</style>